import { ClassAnnotation } from 'Types/Classes.types'
import { TaskMode } from 'Types/Tasks.types'

export const isAnnotationOverlapping = (
    annotationList: ClassAnnotation[],
    fieldPath: string,
    startIndex: number,
    endIndex: number
) => {
    return (
        annotationList.filter(
            annotation =>
                annotation.selection.fieldPath === fieldPath &&
                annotation.selection.startIndex < endIndex &&
                annotation.selection.endIndex > startIndex
        ).length > 0
    )
}

export const isViewerMode = (mode: TaskMode) => {
    return mode === TaskMode.Viewer || mode === TaskMode.TaskViewer
}
